import styled from 'styled-components';
import {basicColor} from '../../../../../styles/template';


const Marker = styled.b`
	color: ${basicColor.red};
`;

export default Marker